import { gql } from '@grandvisionhq/graphql';

const unknownLoyaltyDetailsFailure = gql`
  fragment UnknownSetLoyaltyDetailsFailureFragment on UnknownSetLoyaltyDetailsFailure {
    message
    code
  }
`;

export { unknownLoyaltyDetailsFailure };
//# sourceMappingURL=loyalty-point-failure.js.map
